export default "__VITE_ASSET__6872e56a__"